import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enGB from "./translations/translation.en-GB.json";

const resources = {
  // ar: { translation: ar },
  'en-GB': { translation: enGB },
  // 'en-US': { translation: enUS },
  // fr: { translation: fr },
  // vi: { translation: vi },
  // cn: { translation: cn },
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: "en-GB",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources
  });

export default i18n;
